export const getTableColumnIdDirection = <T>(columnId: T, isSortedDesc: boolean): string | undefined => {
  if (!columnId) {
    return undefined
  }

  return isSortedDesc ? `-${columnId}` : `${columnId}`
}
